module.exports = __webpack_public_path__ + "static/media/accounts@2x.9c27c36c.png";